export default __webpack_public_path__ + "static/media/vivabonito7.d0fdba2f.jpg";